<script setup>
import { ref, nextTick, computed } from 'vue'
/* import { useSelectedLabel } from './component/useSelectedLabel' */
import { translations } from './component/locale'
import { makersOptionsDict, capacityOptionsDict, devicesOptionsDict, powerOptionsDict, currentOptionsDict, kanzaOptionsDict, methodOptionsDict, loadyearOptionsDict, specOptionsDict, oilDeviceBlakeOptionsDict,  } from './component/options'
import { imagePaths } from './component/imageMap'
//  URLから言語を判定
const path = window.location.pathname
const lang = ref('ja')// デフォルトは日本語

if (path.startsWith('/en')) {
  lang.value = 'en'
} else if (path.startsWith('/de')) {
  lang.value = 'de'
}

// form参照 & ステート定義
const formRef = ref(null)
const input_error = ref(false)
const input_success = ref(false)
const show_result = ref(false)
const results_oil = ref(true)
const results_device = ref(true)
const results_brake = ref(true)
const results_bolt_strain_sensor = ref('')
const results_sensor_box = ref('')

// フォーム項目
const maker = ref('') // 風車メーカー
const capacity = ref('') // 発電容量
const devices_number = ref('') // 旋回駆動装置台数
const attached_motor = ref('') // 駆動装置付属モーターKW
const attached_motor_a = ref('') // 駆動装置付属モーターA
const powersupply = ref('1') // 電源
const current = ref('1') // 電流
const size_m = ref('') // 駆動装置締結ボルトサイズ
const size_mm = ref('') // 駆動装置締結ボルトサイズ
const kanza = ref('') // 間座
const method = ref('') // 駆動装置設置方式
const load_year = ref('') // 契約年数
const oil = ref('1') // 駆動装置オイル
const device = ref('1') // 駆動装置 歯車・軸受
const brake = ref('1') // 電磁ブレーキ

// 翻訳選択
const t = computed(() => translations[lang.value] || translations.ja)
// URL 変換関数
const resolveImage = (relativePath) => new URL(relativePath, import.meta.url).href

// 言語ごとに画像を取得
const images = computed(() => {
	const currentLang = lang.value
	return {
		analysis1img: resolveImage(imagePaths.analysis1[currentLang] || imagePaths.analysis1.ja),
		analysis2img: resolveImage(imagePaths.analysis2[currentLang] || imagePaths.analysis2.ja),
		analysis3img: resolveImage(imagePaths.analysis3[currentLang] || imagePaths.analysis3.ja),
		remain1img: resolveImage(imagePaths.remain1[currentLang] || imagePaths.remain1.ja),
		remain1gray: resolveImage(imagePaths.remain1g[currentLang] || imagePaths.remain1g.ja),
		remain2img: resolveImage(imagePaths.remain2[currentLang] || imagePaths.remain2.ja),
		remain2gray: resolveImage(imagePaths.remain2g[currentLang] || imagePaths.remain2g.ja),
		remain3img: resolveImage(imagePaths.remain3[currentLang] || imagePaths.remain3.ja),
		remain3gray: resolveImage(imagePaths.remain3g[currentLang] || imagePaths.remain3g.ja),
	}
})

const makersOptions         = computed(() => makersOptionsDict[lang.value] || makersOptionsDict.ja)
const capacityOptions       = computed(() => capacityOptionsDict[lang.value] || capacityOptionsDict.ja)
const devicesOptions        = computed(() => devicesOptionsDict[lang.value] || devicesOptionsDict.ja)
const powerOptions          = computed(() => powerOptionsDict[lang.value] || powerOptionsDict.ja)
const currentOptions        = computed(() => currentOptionsDict[lang.value] || currentOptionsDict.ja)
const kanzaOptions          = computed(() => kanzaOptionsDict[lang.value] || kanzaOptionsDict.ja)
const methodOptions         = computed(() => methodOptionsDict[lang.value] || methodOptionsDict.ja)
const loadyearOptions       = computed(() => loadyearOptionsDict[lang.value] || loadyearOptionsDict.ja)
const specOptions           = computed(() => specOptionsDict[lang.value] || specOptionsDict.ja)
const oilDeviceBlakeOptions = computed(() => oilDeviceBlakeOptionsDict[lang.value] || oilDeviceBlakeOptionsDict.ja)
/* const makerLabel = useSelectedLabel(makersOptions, maker) */

// 診断処理
const diagnosis = async () => {
	input_error.value = false
	input_success.value = false
	show_result.value = false

	const form = formRef.value
	if (!form) return

	const isValid = form.checkValidity()
	if (!isValid) {
		form.classList.add('was-validated')
		input_error.value = true
		setTimeout(() => {
			input_error.value = false
		}, 2000)
		await nextTick()
		const inputErrorEl = document.getElementById('input-error')
		if (inputErrorEl) {
			inputErrorEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
		}
	return
	}

	// 診断中スピナーを表示
	input_success.value = true
	await nextTick()
	const inputSuccessEl = document.getElementById('input-success')
	if (inputSuccessEl) {
		inputSuccessEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
	}

	// 2秒待機して診断結果を表示
	setTimeout(() => {
		input_success.value = false
		 // デバイス数に応じて結果を計算
		const num = parseInt(devices_number.value)
		results_bolt_strain_sensor.value = isNaN(num) || num === 0 ? '-' : num * 2
		results_sensor_box.value = isNaN(num) || num === 0 ? '-' : num * 1
		results_oil.value = oil.value === "1" ? true : false
		results_device.value = device.value === "1" ? true : false
		results_brake.value = brake.value === "1" ? true : false
		show_result.value = true
	}, 2000)
}
</script>
<template>
<form ref="formRef" class="needs-validation" novalidate>
		<div id="input-error">
		 <transition name="fade" v-cloak>
				<div class="alert alert-danger" role="alert" v-if="input_error">
						{{ t.inputerror }}
				</div>
			</transition>
		</div>
		<div class="d-flex flex-column align-items-md-center">
			<h2 class="mb-5">{{ t.device }}</h2>
			<div class="col-md-5 mb-4">
				<p class="lead">
						{{ t.lead }}
				</p>
				<label class="form-label" for="maker">{{ t.windmillmaker }}</label>
				<select class="form-select" id="maker" name="maker" v-model="maker" required>
					<option value="" selected="selected">
						▼{{ t.placeholder }}
					</option>
					<option v-for="opt in makersOptions" :key="opt.value" :value="opt.value">
						{{ opt.label }}
					</option>
				</select>
				<div class="invalid-feedback">{{ t.placeholder }}</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="capacity">{{ t.capacity }}</label>
				<select class="form-select" id="capacity" name="capacity" v-model="capacity" required>
					<option value="" selected="selected">
						▼{{ t.placeholder }}
					</option>
					<option v-for="opt in capacityOptions" :key="opt.value" :value="opt.value">
						{{ opt.label }}
					</option>
				</select>
				<div class="invalid-feedback">{{ t.placeholder }}</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="devices-number">{{ t.devices }}</label>
				<select class="form-select" id="devices-number" name="devices_number" v-model="devices_number" required>
					<option value="" selected="selected">
						▼{{ t.placeholder }}
					</option>
					<option v-for="opt in devicesOptions" :key="opt.value" :value="opt.value">
						{{ opt.label }}
					</option>
				</select>
				<div class="invalid-feedback">{{ t.placeholder }}</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="attached-motor">{{ t.motor }}</label>
				<div class="d-flex gap-3">
					<div class="input-group has-validation">
						<input class="form-control" name="attached-motor" type="number" value="" placeholder="20" aria-label="" aria-describedby="attached-motor-addon" v-model.trim="attached_motor" required/>
						<span id="attached-motor-addon" class="input-group-text">KW</span>
						<div class="invalid-feedback">{{ t.input }}</div>
					</div>
					<div class="input-group has-validation">
						<input class="form-control" name="attached-motor-a" type="number" value="" placeholder="20" aria-label="" aria-describedby="attached-motor-a-addon" v-model.trim="attached_motor_a" required/>
						<span id="attached-motor-a-addon" class="input-group-text">A</span>
						<div class="invalid-feedback">{{ t.input }}</div>
					</div>
				</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="current">{{ t.ebrake }}</label>
				<div class="mb-2">{{ t.power }}</div>
				<div class="radio-check mb-3">
					<div class="form-check form-check-inline" v-for="opt in powerOptions" :key="opt.value">
						<input class="form-check-input" :id="opt.id" name="powersupply" type="radio" :value="opt.value" v-model="powersupply"/>
						<label class="form-check-label" :for="opt.id">{{ opt.label }}</label>
					</div>
				</div>
				<div class="mb-2">{{ t.current }}</div>
				<div class="radio-check">
					<div class="form-check form-check-inline" v-for="opt in currentOptions" :key="opt.value">
						<input class="form-check-input" :id="opt.id" name="current" type="radio" :value="opt.value" v-model="current"/>
						<label class="form-check-label":for="opt.id">{{ opt.label }}</label>
					</div>
				</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="size">{{ t.boltsize }}</label>
				<div class="d-flex align-items-center gap-2">
					<div class="input-group has-validation">
						<span class="input-group-text" id="basic-addon1">M</span>
						<input type="number" class="form-control" name="size-m" value="" placeholder="20" aria-label="size" aria-describedby="size-m-addon" v-model.trim="size_m" required/>
						<div class="invalid-feedback">{{ t.input }}</div>
					</div>
					<span>X</span>
					<div class="input-group has-validation">
						<input class="form-control" name="attached-motor-a" type="number" value="" placeholder="20" aria-label="" aria-describedby="attached-motor-a-addon" v-model.trim="size_mm" required/>
						<span id="attached-motor-a-addon" class="input-group-text" >mm</span>
						<div class="invalid-feedback">{{ t.input }}</div>
					</div>
				</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="kanza">{{ t.kanza }}
					<button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#kanzaModal">
					{{ t.img }}
					</button></label>
				<select class="form-select" id="kanza" name="kanza" v-model="kanza" required>
					<option value="" selected="selected">
						▼{{ t.placeholder }}
					</option>
					<option v-for="opt in kanzaOptions" :key="opt.value" :value="opt.value">
						{{ opt.label }}
					</option>
				</select>
				<div class="invalid-feedback">{{ t.placeholder }}</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="method">{{ t.method }}
					<button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#methodModal" >
					{{ t.img }}
					</button></label >
				<select class="form-select" id="method" name="method" v-model="method" required >
					<option value="" selected="selected">
						▼{{ t.placeholder }}
					</option>
					<option v-for="opt in methodOptions" :key="opt.value" :value="opt.value">
						{{ opt.label }}
					</option>
				</select>
				<div class="invalid-feedback">{{ t.placeholder }}</div>
			</div>
			<h2 class="mt-5 mb-4">{{ t.service }}</h2>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="load-year">{{ t.loadyear }}</label>
				<select class="form-select" id="load-year" name="load_year" v-model="load_year" required >
				<option value="" selected="selected">
						▼{{ t.placeholder }}
					</option>
					<option v-for="opt in loadyearOptions" :key="opt.value" :value="opt.value">
						{{ opt.label }}
					</option>
				</select>
				<div class="invalid-feedback">{{ t.placeholder }}</div>
			</div>
			<div class="col-md-5 mb-4">
				<p class="fw-bold">
					{{ t.specification }}
				</p>
				<label class="form-label" for="lists">{{ t.load }}</label>
				<ul class="list-unstyled ms-2 mb-0" id="lists">
					<li v-for="opt in specOptions">{{ opt.label }}</li>
				</ul>
			</div>
			<div class="col-md-5 mb-2">
				<p class="fw-bold">	{{ t.option }}</p>
				<label class="form-label" for="remaining-life">{{ t.remaininglife }}</label>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="oil">{{ t.oil }}</label>
				<div class="radio-check">
					<div class="form-check form-check-inline" v-for="opt in oilDeviceBlakeOptions" :key="opt.value">
						<input class="form-check-input" :id="`oil-${opt.id}`" name="oil" type="radio" :value="opt.value" v-model="oil"/>
						<label class="form-check-label":for="`oil-${opt.id}`">{{ opt.label }}</label>
					</div>
				</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="device">{{ t.gear }}</label >
				<div class="radio-check">
					<div class="form-check form-check-inline" v-for="opt in oilDeviceBlakeOptions" :key="opt.value">
						<input class="form-check-input" :id="`device-${opt.id}`" name="device" type="radio" :value="opt.value" v-model="device"/>
						<label class="form-check-label":for="`device-${opt.id}`">{{ opt.label }}</label>
					</div>
				</div>
			</div>
			<div class="col-md-5 mb-4">
				<label class="form-label" for="electromagneticbrake" >{{ t.brake }}</label>
				<div class="radio-check">
					<div class="form-check form-check-inline" v-for="opt in oilDeviceBlakeOptions" :key="opt.value">
						<input class="form-check-input" :id="`brake-${opt.id}`" name="brake" type="radio" :value="opt.value" v-model="brake"/>
						<label class="form-check-label":for="`brake-${opt.id}`">{{ opt.label }}</label>
					</div>
				</div>
			</div>
			<p class="text-center">
				{{ t.exp }}
			</p>
			<p class="my-3">
			 <button class="btn btn-primary" type="button" @click.prevent="diagnosis">{{ t.diagnosis }}</button>
			</p>
		</div>
	</form>

	<div id="input-success" class="diagnosis">
		 <transition name="fade" v-cloak>
			<div class="alert alert-success" role="alert" v-if="input_success">
				<div class="d-flex align-items-center gap-3">
					<h4>{{ t.loading }}</h4>
					<div class="spinner-border text-success" role="status" aria-hidden="true" ></div>
				</div>
			</div>
		</transition>
		<transition name="fade" v-cloak>
			<div id="diagnosis-result" v-if="show_result">
				<div class="results-contents">
					<div class="container">
						<h3 class="text-center mb-5">{{ t.product }}</h3>
						<div class="equipment-selection">
							<div class="results-title">{{ t.equipment }}</div>
							<p class="text-center">
								{{ t.equiptext }}
							</p>
							<div class="d-flex flex-column flex-md-row justify-content-md-center" >
								<div class="es-box">
									<div class="es-title">{{ t.equip1 }}</div>
									<div class="es-img">
										<img class="img-fluid" src="../../img/es-bolt-strain-sensor.jpg" :alt="t.equip1" width="280" height="187" />
									</div>
									<div class="es-num">
										{{ results_bolt_strain_sensor }}
									</div>
								</div>
								<div class="es-box">
									<div class="es-title">{{ t.equip2 }}</div>
									<div class="es-img">
										<img class="img-fluid" src="../../img/es-sensor-box.jpg" :alt="t.equip2" width="280" height="187" />
									</div>
									<div class="es-num">
										{{ results_sensor_box }}
									</div>
								</div>
								<div class="es-box">
									<div class="es-title">{{ t.equip3 }}</div>
									<div class="es-img">
										<img class="img-fluid" src="../../img/es-control-box.jpg" :alt="t.equip3" width="280" height="187" />
									</div>
									<div class="es-num">1</div>
								</div>
								<div class="es-box">
									<div class="es-title">{{ t.equip4 }}</div>
									<div class="es-img">
										<img class="img-fluid" src="../../img/es-power-box.jpg" :alt="t.equip4" width="280" height="187" />
									</div>
									<div class="es-num">1</div>
								</div>
							</div>
							<p class="text-md-end">
								<small >{{ t.equipnote }}</small >
							</p>
						</div>
						<div class="load-analysis">
							<div class="results-title">{{ t.analysis }}</div>
							<div class="d-flex flex-column flex-md-row justify-content-md-center" >
								<div class="analysis-box">
									<div class="analysis-title">
										{{ t.ana1 }}
									</div>
									<div class="analysis-img">
										<img class="img-fluid" :src="images.analysis1img" :alt="t.ana1" width="200" />
									</div>
								</div>
								<div class="analysis-box">
									<div class="analysis-title">
										{{ t.ana2 }}
									</div>
									<div class="analysis-img">
										<img class="img-fluid" :src="images.analysis2img" :alt="t.ana2" width="300" />
									</div>
								</div>
								<div class="analysis-box">
									<div class="analysis-title">
										{{ t.ana3 }}
									</div>
									<div class="analysis-img">
										<img class="img-fluid" :src="images.analysis3img" :alt="t.ana3" width="500" />
									</div>
								</div>
							</div>
						</div>
						<div class="remaining-life-diagnosis">
							<div class="results-title">{{ t.remainsample }}</div>
							<div class="d-flex flex-column flex-md-row justify-content-md-center" >
								<div class="diagnosis-box">
									<p class="mb-0" v-if="results_oil">
										<img class="img-fluid" :src="images.remain1img" :alt="t.oil" width="300" />
									</p>
									<p class="mb-0" v-else>
										<img class="img-fluid" :src="images.remain1gray" :alt="t.oil" width="300" />
									</p>
								</div>

								<div class="diagnosis-box">
									<p class="mb-0" v-if="results_device">
										<img class="img-fluid" :src="images.remain2img" :alt="t.gear" width="300" />
									</p>
									<p class="mb-0" v-else>
										<img class="img-fluid" :src="images.remain2gray" :alt="t.gear" width="300" />
									</p>
								</div>
								<div class="diagnosis-box">
									<p class="mb-0" v-if="results_brake">
										<img class="img-fluid" :src="images.remain3img" :alt="t.brake" width="300" />
									</p>
									<p class="mb-0" v-else>
										<img class="img-fluid" :src="images.remain3gray" :alt="t.brake" width="300" />
									</p>
								</div>
							</div>
						</div>
					</div>
					<!-- // container -->
					<div class="container">
						<form :action="t.action" method="get" class="form" >
							<input type="hidden" name="maker" :value="maker" id="maker_results" />
							<input type="hidden" name="capacity" :value="capacity" id="capacity_results" />
							<input type="hidden" name="devices_number" :value="devices_number" id="devices_number_results" />
							<input type="hidden" name="attached_motor_kw" :value="attached_motor" id="attached_motor_kw_results" />
							<input type="hidden" name="attached_motor_a" :value="attached_motor_a" id="attached_motor_a_results" />
							<input type="hidden" name="powersupply" :value="powersupply" id="powersupply_results" />
							<input type="hidden" name="current" :value="current" id="current_results" />
							<input type="hidden" name="boltsize_m" :value="size_m" id="boltsize_m_results" />
							<input type="hidden" name="boltsize_mm" :value="size_mm" id="boltsize_mm_results" />
							<input type="hidden" name="kanza" :value="kanza" id="kanza_results" />
							<input type="hidden" name="method" :value="method" id="method_results" />
							<input type="hidden" name="load_year" :value="load_year" id="load_year_results" />
							<input type="hidden" name="oil" :value="oil" id="oil_results" />
							<input type="hidden" name="device" :value="device" id="device_results" />
							<input type="hidden" name="brake" :value="brake" id="brake_results" />
							<input type="hidden" name="dummy_n" value="1" />
							<input type="hidden" name="dummy_b" value="2" />
							<input type="hidden" name="dummy_c" value="3" />
							<p class="text-center">
								<input type="submit" :value="t.mailbtn" id="submit" class="btn btn-secondary" />
							</p>
						</form>
					</div>
				</div>
				<!-- // resutls-contents -->
			</div>
			<!-- // resutls--->
		</transition>
	</div>
</template>
